import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2425289867/src/src/components/ecommerce/product/ProductPage.tsx");
